export default __webpack_public_path__ + "assets/webgl/matcap_white.9171384e.jpg";